import React from 'react';
import NewApp from './newSrc/App.jsx';

const  App = () : React.ReactElement => {
  return (
    <div className='bg-[#151412] '>
    <div className='min-h-screen'>
        {/* <Home /> */}
        <NewApp />
    </div>
    </div>
  );
}

export default App;
